import {React, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import validator from 'validator'

import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'

import userStore from "../../store/slice/auth.slice"
import toast from 'react-hot-toast'

import doUtility from '../utility'

function SignIn(){
    
    const navigate =  useNavigate()

    const login = userStore((state) => state.login)

    const response  = userStore((state) => state.response)
    
    const { register, handleSubmit, formState: { errors } } = useForm()

    const [passwordShown, setPasswordShown] = useState(false)

    const togglePassword = () => {              
        setPasswordShown(!passwordShown);
    }

    const [btndisable, setbtndisable] = useState(true)

    const emailChange = (e) => {
        if(validator.isEmail(e.target.value)){
            var check = doUtility.emailVerification(e.target.value)
            if(check){
                setbtndisable(false)
                toast.dismiss()
            }else{
                toast.error('Provided Email Not Allowed', { id: "copy" })
                setbtndisable(true)
            }
        }
    }

    useEffect(() => {
        if(response){
            if(response.response_code === '01'){
                toast.success(response.message)
                window.setTimeout(() => {
                    navigate('/dashboard')
                }, 2000)
            }else{
                toast.error(response.message)
            }

            userStore.setState({ response: false })
        }
    },[response, navigate])
    
    const onSubmit = (data) => {
        login(data.username, data.password)        
    }
    
    return (
        <div className="login-signup-form-container">
            <form className="login-form" onSubmit={handleSubmit(onSubmit)} autoComplete='false'>
                <div className="form-heading">
                    <p>Please Enter Email &amp; Password For Login</p>
                </div>

                <div className="form-inputs">
                    <input type="email" name="username" placeholder="Enter Email Address" autoComplete='false'
                        {...register("username", {required: true})} onChange={emailChange} />
                    <div className="message">{errors.username && <span>This field is required</span>}</div>

                    <div>
                        <input type={passwordShown ? "text" : "password"} name="password" placeholder="Enter Password" autoComplete='false'
                            {...register("password", {required:true})} />

                        <span className="field-icon" onClick={togglePassword}> {passwordShown ? <EyeTwoTone/>  : <EyeInvisibleOutlined/>} </span>
                        
                        <div className="message">{errors.password && <span>This field is required</span>}</div>
                    </div>
                    
                    <div className="forgetpasswordlink"> <Link to="/auth/forgetpassword">Forget Password </Link></div>
                
                </div>

                {btndisable}

                <div className="button login-signup-btn">
                    <button type="submit" className="lsbtn" onClick={(e)=>{return false}} disabled={btndisable}  > Sign In </button>
                    <Link to="/auth/signup"> <button type="button" className="signup">Sign Up</button> </Link>
                </div>
            </form>
        </div>
    )
}

export default SignIn